import React from 'react'

const UpArrow = ({ width = 16, height = 16 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none">
      <g clip-path="url(#clip0_26175_4160)">
        <path
          d="M8.00328 0.00537249C10.1241 0.00549365 12.1579 0.848496 13.6576 2.34815C15.1572 3.84785 16.0003 5.8816 16.0003 8.00244C16.0003 9.5841 15.5314 11.1307 14.6527 12.4458C13.774 13.7609 12.5241 14.7858 11.0628 15.3911C9.60167 15.9963 7.99388 16.1547 6.44273 15.8462C4.8915 15.5376 3.4664 14.7761 2.348 13.6577C1.22963 12.5393 0.468128 11.1142 0.159526 9.56299C-0.149046 8.01169 0.00931872 6.40318 0.614605 4.94189C1.21991 3.48076 2.2449 2.23169 3.55992 1.35303C4.87501 0.474353 6.42165 0.00537222 8.00328 0.00537249ZM8.00328 1.14209C6.1844 1.1436 4.43988 1.86678 3.15367 3.15283C1.86746 4.43904 1.1435 6.18348 1.14195 8.00244C1.14195 9.3592 1.54448 10.6858 2.2982 11.814C3.05197 12.9421 4.12386 13.8211 5.3773 14.3403C6.63087 14.8596 8.01038 14.9957 9.34117 14.731C10.6719 14.4663 11.8944 13.8134 12.8539 12.854C13.8133 11.8946 14.4671 10.672 14.7318 9.34131C14.9965 8.0106 14.8603 6.63096 14.3412 5.37744C13.8219 4.12387 12.942 3.05217 11.8138 2.29834C10.6858 1.54474 9.35984 1.14218 8.00328 1.14209ZM8.00328 3.56201C8.37125 3.56227 8.66929 3.86097 8.66929 4.22901L8.66929 12.0269C8.66923 12.3948 8.37122 12.6936 8.00328 12.6938C7.63512 12.6938 7.33634 12.395 7.33628 12.0269L7.33628 4.22901C7.33628 3.86082 7.63509 3.56201 8.00328 3.56201Z"
          fill="#5F5F5F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.58768 3.58736C7.81549 3.35955 8.18484 3.35955 8.41264 3.58736L12.496 7.67069C12.7238 7.8985 12.7238 8.26784 12.496 8.49565C12.2682 8.72346 11.8988 8.72346 11.671 8.49565L8.00016 4.8248L4.32931 8.49565C4.1015 8.72346 3.73216 8.72346 3.50435 8.49565C3.27654 8.26784 3.27654 7.8985 3.50435 7.67069L7.58768 3.58736Z"
          fill="#5F5F5F"
        />
      </g>
      <defs>
        <clipPath id="clip0_26175_4160">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(16 16) rotate(-180)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
export default UpArrow
export { UpArrow }
